import { ConstantType, MenuType, RoleType } from "@/@types/response";
import { get_constant, get_menus } from "@/libs/general";
import { list_role } from "@/libs/role";
import { create } from "zustand";

interface ConstantStoreType {
  constant: ConstantType[] | null;
  getConstant: () => Promise<void>;
  role: RoleType[] | null;
  getRole: () => Promise<void>;
  menu: MenuType[] | null;
  getMenu: () => Promise<void>;
}
export const useGeneralStore = create<ConstantStoreType>((set) => ({
  async getConstant() {
    const result = await get_constant();
    set((state) => ({ ...state, constant: result?.data?.constants || [] }));
  },
  constant: null,
  async getRole() {
    const result = await list_role({ limit: 100, page: 1, search: "" });
    set((state) => ({ ...state, role: result?.data?.roles || [] }));
  },
  role: null,
  menu: null,
  async getMenu() {
    const result = await get_menus();
    set((state) => ({ ...state, menu: result?.data?.menus || [] }));
  },
}));
